export default "__VITE_ASSET__2a676fdb__"